import { useHotkeys } from 'react-hotkeys-hook';
import { useDispatch } from 'react-redux';
import { setViewSettingsModalOpen } from '../../../untidy/redux/actions/actions';
import { useIsTeam } from '../hooks';

/**
 * App-shell-level global hotkeys (PLT-4824). Mounted once near the root so
 * the bindings work on every route — including pages that don't render the
 * status bar. Specific bindings:
 *
 * - `Ctrl/Cmd + Shift + 8` (a.k.a. `Ctrl+*`) → open the View settings modal
 *   (`setViewSettingsModalOpen(true)`). Team-gated; non-team users press
 *   the chord to a no-op so accidental misfires from clients don't surface
 *   anything in the UI.
 *
 * Future global bindings (e.g. the existing `Alt+P` for the internal-tools
 * bar) should migrate here too — keeping them inside `BouStatusBar` silently
 * breaks them on routes without the status bar.
 */
export function GlobalHotkeys() {
  const dispatch = useDispatch();
  const isTeam = useIsTeam();

  useHotkeys(
    // Register both modifiers as a comma-separated key list (hotkeys-js
    // syntax) so the binding fires on Mac (Cmd) and on Windows / Linux
    // (Ctrl). `shift+8` is `*` on US English keyboards; localised layouts
    // may produce different glyphs but the underlying key event is the same
    // so the chord still fires.
    'ctrl+shift+8, meta+shift+8',
    event => {
      if (!isTeam) {
        return;
      }
      event.preventDefault();
      dispatch(setViewSettingsModalOpen(true));
    },
    [isTeam, dispatch],
  );

  return null;
}
